import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { NewOpenChartComponent } from './components/mb-dashboard/new-open-chart/new-open-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MonthlyChartComponent } from './components/mb-dashboard/monthly-chart/monthly-chart.component';
import { NewOpenBranchChartComponent } from './components/mb-dashboard/new-open-branch-chart/new-open-branch-chart.component';

@NgModule({
  declarations: [
    NewOpenChartComponent,
    MonthlyChartComponent,
    NewOpenBranchChartComponent
  ],
  imports: [
    CommonModule,
    UiModule,
    NgApexchartsModule
  ],
  exports: [
    NewOpenChartComponent,
    MonthlyChartComponent,
    NewOpenBranchChartComponent
  ]
})
export class SharedModule { }
